<template>
  <div id="c-console-panel" ref="consoleLogWrapper" @click="consoleLogFocus">
    <div class="console-data" v-html="consoleLog"></div>
    <div v-show="isRunning && needInput" class="console-input">
      <div style="padding-right: 5px">> </div>
      <input ref="consoleLogInput" rows="1" class="input-tf" type="text" v-model="inputText"
              @keydown.enter="consoleInput" @keyup="consoleKeyup($event)" :disabled="false && !isRunning" /></div>
  </div>
</template>

<script type="text/babel">
  import { mapGetters } from 'vuex';
  import { onEvent } from '../../utils/eventBus/vueEvent';
  import Events from '../../scripts/events/index';
  import iframe from '../../scripts/iframe/index'
  import Socket from '../../scripts/socket/index'
  import consoleStyle from './consoleStyle'
  import HttpRunner from '../../scripts/http-runner';
import Language from '../../scripts/common/language'

  export default {
    name: 'c-console-panel',
    data() {
      return {
        consoleLog: '',
        inputText: '',
        logArr: [],
        step: 0.001,
        needInput: true
      }
    },
    computed: {
      ...mapGetters(['runToken', 'isRunning', 'isRunLocal', 'runningData', 'isPyRuntimeCom', 'language']),
    },
    mounted() {
      onEvent(Events.OUTPUT_CONSOLE, data => {
        if (data) {
          if (data.clear) {
            this.logArr = []
            this.needInput = false
            if (!data.result) {
              this.consoleLog = ''
              return;
            }
          }
          if (data.resort) {
            let start = 0
            for (let i = this.logArr.length - 1; i >= 0; i -= 1) {
              start -= this.step
              this.logArr[i].lineId = start
            }
          }
          if (typeof data === 'object') {
            this.setLog(data)
          } else {
            this.setLocalLog(data)
          }
        }
      })

      onEvent(Events.NEED_INPUT, () => {
        this.needInput = true
        this.consoleLogFocus()
        // this.setLocalLog('<b>wait input:</b>')
      })
    },
    methods: {
      consoleLogFocus() {
        this.$refs.consoleLogInput.focus()
      },
      setLocalLog(result) {
        let lineId = -1;
        if (this.logArr.length) {
          lineId = this.logArr[this.logArr.length - 1].lineId + this.step
        }
        this.setLog({ lineId, runToken: this.runToken, result })
      },
      setLog(data) {
        if (!data) {
          return
        }
        // if (this.runToken !== data.runToken) {
        //   return false
        // }
        if (!data.lineTime && !data.isOutput) {
          data.lineTime = this.getTime()
        }
        if (!data.lineId && data.lineId !== 0) {
          if (this.logArr.length) {
            data.lineId = this.logArr[this.logArr.length - 1].lineId + this.step
          } else {
            data.lineId = -1
          }
        }
        if (this.logArr.length) {
          for (let i = this.logArr.length - 1; i >= 0; i -= 1) {
            if (this.logArr[i].lineId < data.lineId) {
              this.logArr.splice(i + 1, 0, data)
              break;
            } else if (i == 0) {
              this.logArr.unshift(data)
            }
          }
        } else {
          this.logArr.push(data)
        }

        if (this.logArr.length > 100) {
          this.logArr = this.logArr.slice(this.logArr.length - 100)
        }

        this.consoleLog = ''
        for (let item of this.logArr) {
          this.consoleLog = `${this.consoleLog}<pre>${item.lineTime || ''}${item.result || '&nbsp;'}</pre>`
        }
        this.$nextTick(() => {
          this.$refs.consoleLogWrapper.scrollTop = this.$refs.consoleLogWrapper.scrollHeight
        })
      },
      getTime() {
        const date = new Date();
        const houers = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
        const min = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
        const sec = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()
        return consoleStyle.getLineTime(`${houers}:${min}:${sec} `)
      },
      consoleInput(event) {
        console.log('--input--:', this.inputText)
        if (!this.inputText) {
          if (Language.py.value === this.language.value) {
            this.$message.warning('输入不能为空')
            return false
          }
          this.inputText = '\n'
        }
        if (this.isRunLocal) {
          iframe.inputPythonLocal(this.inputText, this.isPyRuntimeCom)
        } else {
          if (HttpRunner.isHttp()) {
            HttpRunner.input(this.runningData, this.inputText, this.$route.query)
          } else {
            Socket.input(this.runningData, this.inputText, this.$route.query)
          }
        }
        event.returnValue = false
        this.setLocalLog(`${consoleStyle.getInput(">:")} ${consoleStyle.getOutput(this.inputText)}`)
        this.inputText = ''
      },
      consoleKeyup() {
        // this.$refs.consoleLogInput.style.height = `${this.$refs.consoleLogInput.scrollHeight}px`
      },
    }
  }
</script>

<style lang="scss" scoped>

  @import "../../assets/scss/base/variables.scss";

  #c-console-panel {
    flex-grow: 1;
    height: 50px;
    overflow: auto;
    padding: $i-s;
    border: 1px solid $c-border-e8;
    margin: 0px $i-s $i-s $i-s;
    background-color: white;

    .console-data {
      color: black;
      padding-left: 10px;
      font-size: 14px;
    }

    .console-input {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: chartreuse;
      padding-left: 10px;
    }
    .input-tf {
      outline: none;
      height: 35px;
      flex-grow: 1;
      border: none;
      background-color: white;
      color: black;
    }
  }
</style>
